import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class AdjustmentListPageStyle extends CommonComponentStyle {
  GridWrapper = styled(Grid)`
    padding: 8px 0;
  `;

  ListGrid = styled(Grid)`
    font-size: 16px;
    font-weight: 700;
  `;

  FlexGrid = styled(Grid)`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `;

  ContentWrapper = styled.div`
    padding: 16px;
    padding-bottom: 80px;
  `;

  StickyFooterWrapper = styled(this.FooterWrapper)`
    position: sticky;
    align-items: center;
    justify-content: center;
  `;
}

export default new AdjustmentListPageStyle();
